import pickBy from 'lodash/pickBy';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import { DateTimeFormats } from 'brock-date-time';
import {
    groupAxisFormatTypes,
    noDataIdentifier,
    precisionTypes,
} from '../../../shared/constants/constants';

export function replaceInArray(newItem, collection, index) {
    return [
        ...collection.slice(0, index),
        newItem,
        ...collection.slice(index + 1),
    ];
}

export function removeFromArray(collection, index) {
    return [...collection.slice(0, index), ...collection.slice(index + 1)];
}

export function getRandomColor() {
    return `#${Math.random().toString(16).slice(-6)}`;
}

/* eslint-disable complexity */
export function getTimeSeriesTickFormatter(precisionType) {
    return (t) => {
        switch (precisionType) {
            case precisionTypes.minute:
            case precisionTypes.hour: {
                return moment(t).format('MM-DD HH:mm');
            }

            case precisionTypes.day:
            case precisionTypes.week: {
                return moment(t)
                    .format(DateTimeFormats.DATE_IATA)
                    .toUpperCase();
            }

            case precisionTypes.month: {
                return moment(t).format('YYYY-MM');
            }

            case precisionTypes.quarter: {
                return moment(t).format('YYYY-[Q]Q');
            }

            case precisionTypes.year: {
                return moment(t).format('YYYY');
            }

            default: {
                return moment(t).format(DateTimeFormats.DATETIME);
            }
        }
    };
}
/* eslint-enable complexity */

export function flattenArray(arrays) {
    return [].concat(...arrays);
}

export function getUniqueArray(arr) {
    return [...new Set(arr)];
}

export function getLegendFormatter(friendlyLegendLabels, friendlyColumnLabels) {
    return (value, entry, index) =>
        friendlyLegendLabels?.[index] || friendlyColumnLabels?.[value] || value;
}

// DateParts in moment are zero based indexed
/* eslint-disable complexity */
export function getGroupAxisFormatter(
    groupAxisFormatType,
    groupAxisFormatProps,
    legendFormatter
) {
    switch (groupAxisFormatType) {
        case groupAxisFormatTypes.dateMonthShort: {
            return (t) => moment().month(t).format('MMM');
        }

        case groupAxisFormatTypes.dateMonthFull: {
            return (t) => moment().month(t).format('MMMM');
        }

        case groupAxisFormatTypes.dateConfigured: {
            const { datePart, format } = groupAxisFormatProps;

            return (t) => moment()[datePart](t).format(format);
        }

        default: {
            return legendFormatter;
        }
    }
}
/* eslint-enable complexity */

export function getErrorMessageKey(errorKey, thresholdErrorKey) {
    return errorKey || thresholdErrorKey;
}

// eslint-disable-next-line complexity
export function getFormattedGaugeValue(
    gaugeValue,
    formatValue,
    suffix,
    formatType
) {
    if (gaugeValue === null || gaugeValue === undefined) {
        return noDataIdentifier;
    }

    const formattedGaugeValue = gaugeValue
        ? formatValue(gaugeValue, formatType).toLocaleString()
        : 0;

    const suffixValue = suffix ?? '';

    return `${formattedGaugeValue}${suffixValue}`;
}

// eslint-disable-next-line complexity
export function getFormattedThresholdValue(
    thresholdConfig,
    formatValue,
    suffix,
    formatType
) {
    if (!thresholdConfig) {
        return null;
    }

    if (thresholdConfig.stringValue) {
        return thresholdConfig.stringValue;
    }

    const suffixValue = suffix ?? '';

    // prettier-ignore
    return thresholdConfig.value !== null && thresholdConfig.value !== undefined
        ? `${formatValue(
            thresholdConfig.value,
            formatType
        ).toLocaleString()}${suffixValue}`
        : noDataIdentifier;
}

export function getFormattedTimeFromMilliseconds(value, timeFormat) {
    momentDurationFormatSetup(moment);

    if (timeFormat) {
        return moment.duration(value).format(timeFormat, { trunc: true });
    }
    return moment.duration(value).format('*HH:mm', { trunc: true });
}

export function removeNullOrUndefinedProperties(obj) {
    return pickBy(obj, (value) => value !== null && value !== undefined);
}
